
import { login } from '@/api/Login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setCookies, getCookies } from '@/utils/cookies'
import { handleLimits } from '@/utils/tool'
import router from '@/router'
import { getUserDetails } from "@/api/User";


const getDefaultState = () => {
  return {
    token: getToken(),
    nameInfo: localStorage.getItem('nickname') || null,
    userId: getCookies('uId') || null,
    userInfo: null,
    limit: [],
    menuAccess: [],
    btnLimit: [],
    firstTime: false
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {      //重置state
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {    //存储token
    state.token = token
  },
  SET_USERID: (state, user) => {
    state.userId = user
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_LIMIT: (state, limit) => {
    state.limit = limit
  },
  SET_MENUACCESS: (state, data) => {
    state.menuAccess = data
  },
  SET_BTNLIMIT: (state, btnLimit) => {
    state.btnLimit = btnLimit
  },
  SET_FIRSTTIME: (state, firstTime) => {
    state.firstTime = firstTime
  },
}

const actions = {

  // 用户登录
  userlogin({ commit }, userInfo) {
    const { userName, passWord } = userInfo
    return new Promise((resolve, reject) => {
      // 调用登录接口
      login(userInfo).then(response => {
        commit('SET_USERID', response.data.data.userId)
        setCookies('uId', response.data.data.userId)
        const token = response.headers.authorization
        // 存到vuex中
        commit('SET_TOKEN', token)
        //vux在刷新时 会重启  所以将token存到cookie中
        setToken(token)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.userId) {
        removeToken()
        router.push('/login')
      }
      getUserDetails({ userId: state.userId }).then(res => {
        if (res.code == 20000) {
          commit('SET_FIRSTTIME', res.data.user.firstTime)
          let btnMenu = []
          res.data.menu.forEach(item => {
            if (item.buttonName) {
              btnMenu.push(item.buttonName)
            }
          });
          let limitMenu = []
          res.data.menu.forEach(item => {
            if (item.buttomGroup == 1) {
              limitMenu.push(item)
            }
          });
          commit('SET_MENUACCESS', limitMenu)
          limitMenu = handleLimits(limitMenu)
          commit('SET_LIMIT', limitMenu)
          commit('SET_BTNLIMIT', btnMenu)
          const { data } = res
          commit('SET_USERINFO', res.data.user)
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }



}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

